module.exports = __webpack_public_path__ + "static/9-1862c4e4aef7ed34a5b91fc100d95e92.png";